import { Box, styled, Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { DataPointTooltip, LwBlockGridContainer, theme } from 'redesign';
import { useEffect, useState } from 'react';
import { ShiftOverviewChartResponse } from 'api/services/dashboard/dashboard-service.schema';
import { HeaderComponent } from '../shared/components/header-component';

export const ShiftOverviewChart = ({
  dataset,
  chartTitle,
}: {
  dataset: ShiftOverviewChartResponse | undefined;
  chartTitle: string;
}) => {
  useEffect(() => {
    const handleResize = () => {
      setChartWidth(window.innerWidth - 100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isLoading = !dataset?.length;
  const [chartWidth, setChartWidth] = useState(window.innerWidth - 100);
  const ticks = dataset ? Array.from({ length: dataset.length }, (_, i) => i) : [];

  return (
    <StyledDashboardChartBox>
      <HeaderComponent titleText="Shift Overview" downloadUrl="#" />
      <StyledLineChartContainer data-testid="dashboard-chart">
        <Typography variant="body1">{!isLoading ? chartTitle : ''}</Typography>
        <LineChart
          loading={isLoading}
          dataset={dataset ?? []}
          colors={[theme.palette.lwPrimary[100]]}
          height={500}
          width={chartWidth}
          xAxis={[
            {
              dataKey: 'label',
              data: ticks,
              tickNumber: ticks.length,
              tickSize: 0,
              disableLine: true,
              valueFormatter: (value) => (dataset ? dataset[value]?.label : ''),
              label: 'Weken',
            },
          ]}
          yAxis={[{ disableTicks: true, disableLine: true, label: 'Uren' }]}
          rightAxis={{ disableLine: true, label: '' }}
          series={[
            {
              dataKey: 'value',
            },
          ]}
          grid={{ horizontal: true }}
          slots={{
            axisContent: (props) => {
              const index = props.dataIndex ?? 0;
              const label = dataset ? dataset[index]?.label : '';
              const value = dataset ? `${dataset[index]?.value} uren` : '';

              return <DataPointTooltip label={label} value={value} />;
            },
          }}
        />
      </StyledLineChartContainer>
    </StyledDashboardChartBox>
  );
};

const StyledLineChartContainer = styled(LwBlockGridContainer)(({ theme }) => ({
  borderRadius: '32px',
  boxShadow: theme.shadows[3],
  marginTop: '8px',
  paddingTop: '12px',
  display: 'flex',
  justifyContent: 'center',
}));
const StyledDashboardChartBox = styled(Box)(() => ({
  gridColumn: 'span 2',
  width: '100%',
  paddingLeft: '12px',
}));
